import { anchorScroll } from "./modules/anchor"
import { pagetoTop } from "./modules/back-top"
import { initCustomSelect } from "./modules/customSelect"
import { tabList } from "./modules/tabs"

const actionChecked = (object) => {
  $(object).each(function () {
    let btnAction = $(this).find('.action-checkbox');
    let btnClick = btnAction.find('.btn--checkbox');
    let objectCheckbox = $(this).find('.checkbox');
    btnClick.on('click', function () {
      btnClick.removeClass("checked");
      $(this).addClass("checked");

      if ($(this).hasClass('--all')) {
        objectCheckbox.prop('checked', true);
      } else if ($(this).hasClass('--cancel')) {
        objectCheckbox.prop('checked', false);
      }
    });
  });
}

$(function () {
  pagetoTop();
  anchorScroll();
  initCustomSelect('.group--select > .field-control');
  tabList();
  actionChecked('.form');
})
